// A small dropdown menu (the board's "more" menu).
import { h } from '../util/dom.ts';

export interface MenuItem { label: string; hint?: string; run: () => void }

export function menuButton(label: string, content: string, items: () => (MenuItem | 'separator')[]): HTMLElement {
  const button = h('button', { type: 'button', class: 'tb-btn', title: label, 'aria-label': label, 'aria-haspopup': 'menu', 'aria-expanded': 'false' });
  button.innerHTML = content;
  const menu = h('div', { class: 'panel menu', role: 'menu', hidden: '' });
  const wrap = h('div', { class: 'menu-wrap' }, [button, menu]);

  const close = () => {
    menu.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    document.removeEventListener('pointerdown', outside, true);
    document.removeEventListener('keydown', onKey, true);
  };
  const outside = (e: Event) => { if (!wrap.contains(e.target as Node)) close(); };
  const onKey = (e: KeyboardEvent) => {
    if (e.key === 'Escape') { e.stopPropagation(); close(); button.focus(); }
  };

  button.addEventListener('click', () => {
    if (!menu.hidden) return close();
    menu.replaceChildren(...items().map((item) => {
      if (item === 'separator') return h('div', { class: 'menu-sep', role: 'separator' });
      const b = h('button', { type: 'button', role: 'menuitem', class: 'menu-item' }, [
        h('span', {}, [item.label]), ...(item.hint ? [h('kbd', {}, [item.hint])] : []),
      ]);
      b.addEventListener('click', () => { close(); item.run(); });
      return b;
    }));
    menu.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    (menu.querySelector('.menu-item') as HTMLElement | null)?.focus();
    document.addEventListener('pointerdown', outside, true);
    document.addEventListener('keydown', onKey, true);
  });
  return wrap;
}
